const COOKIE_OVER_18_YEARS_OLD = "over_18_years_old";
const setCookieOver18YearOld = (value, exTime = 720) => {
  if (typeof document !== "undefined") {
    const d = new Date();
    d.setTime(d.getTime() + exTime * 60 * 60 * 1e3);
    const expires = `expires=${d.toUTCString()}`;
    document.cookie = `${COOKIE_OVER_18_YEARS_OLD}=${value};${expires};path=/`;
  }
};
const getCookieOver18YearOld = () => {
  if (typeof document !== "undefined") {
    const name = `${COOKIE_OVER_18_YEARS_OLD}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length) === "true";
      }
    }
  }
  return false;
};

export { COOKIE_OVER_18_YEARS_OLD, getCookieOver18YearOld, setCookieOver18YearOld };
